module.exports = __webpack_public_path__ + "static/img/umweltfreundlich.2b8bb4a8.svg";